module.exports = __webpack_public_path__ + "static/alink-logo-fc0d75d69b7bc30c69928d1c2ac16e6a.png";